export default function ReactLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-11.5 -10.23174 23 20.46348"
    >
      <circle className="dark:fill-white" fill="#545454" r="2.05" />
      <g
        className="dark:stroke-white"
        stroke="#545454"
        strokeWidth="1"
        fill="none"
      >
        <ellipse rx="11" ry="4.2" />
        <ellipse rx="11" ry="4.2" transform="rotate(60)" />
        <ellipse rx="11" ry="4.2" transform="rotate(120)" />
      </g>
    </svg>
  );
}
